import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-heading font-bold text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function KpiCard({ label, value, icon: Icon, accent = "indigo", testid }) {
  const accents = {
    indigo: "bg-indigo-50 text-indigo-600",
    emerald: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600",
    rose: "bg-rose-50 text-rose-600",
    sky: "bg-sky-50 text-sky-600",
    violet: "bg-violet-50 text-violet-600",
  };
  return (
    <div data-testid={testid} className="bg-white rounded-xl border border-slate-200 p-4 flex items-center gap-4 hover:shadow-md transition-shadow">
      {Icon && <div className={cn("h-11 w-11 rounded-lg flex items-center justify-center shrink-0", accents[accent])}><Icon size={20} /></div>}
      <div className="min-w-0">
        <div className="text-2xl font-heading font-bold text-slate-900 font-mono">{value}</div>
        <div className="text-xs text-slate-500 truncate">{label}</div>
      </div>
    </div>
  );
}

const SCORE_STYLES = {
  Prioritaire: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Bon: "bg-sky-100 text-sky-700 border-sky-200",
  Moyen: "bg-amber-100 text-amber-700 border-amber-200",
  Faible: "bg-slate-100 text-slate-500 border-slate-200",
};

export function ScoreBadge({ score, category }) {
  const cat = category || (score >= 81 ? "Prioritaire" : score >= 61 ? "Bon" : score >= 31 ? "Moyen" : "Faible");
  return (
    <span className={cn("inline-flex items-center gap-1 px-2 py-0.5 rounded-md border text-xs font-semibold font-mono", SCORE_STYLES[cat])}>
      {score ?? 0}
    </span>
  );
}

const STATUS_COLORS = {
  "Nouveau": "bg-slate-100 text-slate-600",
  "À qualifier": "bg-violet-100 text-violet-700",
  "À contacter": "bg-blue-100 text-blue-700",
  "Contacté": "bg-cyan-100 text-cyan-700",
  "En discussion": "bg-indigo-100 text-indigo-700",
  "Rendez-vous prévu": "bg-amber-100 text-amber-700",
  "Proposition envoyée": "bg-orange-100 text-orange-700",
  "Négociation": "bg-fuchsia-100 text-fuchsia-700",
  "Gagné": "bg-emerald-100 text-emerald-700",
  "Perdu": "bg-rose-100 text-rose-700",
  "À rappeler": "bg-yellow-100 text-yellow-700",
};

export function StatusBadge({ status }) {
  return (
    <span className={cn("inline-flex px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap", STATUS_COLORS[status] || "bg-slate-100 text-slate-600")}>
      {status || "—"}
    </span>
  );
}

export function Loader({ label = "Chargement…" }) {
  return (
    <div className="flex items-center justify-center py-20 text-slate-400 gap-3">
      <div className="h-5 w-5 rounded-full border-2 border-indigo-500 border-t-transparent animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function Empty({ label = "Aucune donnée", icon: Icon }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-slate-400">
      {Icon && <Icon size={40} className="mb-3 opacity-50" />}
      <p className="text-sm">{label}</p>
    </div>
  );
}
